
import JobTemplateIcon from "assets/images/jobs-template/JobTemplateIcon.png";
import CultureAndTeamFit from "assets/images/jobs-template/Culture and Team Fit.png";
import DiversityAndInclusion from "assets/images/jobs-template/Diversity and Inclusion.png";
import GenericAssessments from "assets/images/jobs-template/Generic Assessments.png";
import GraduateAndEntryLevelHiring from "assets/images/jobs-template/Graduate and Entry-Level Hiring.png";
import HighVolumeHiring from "assets/images/jobs-template/High-Volume Hiring.png";
import IndustrySpecificRoles from "assets/images/jobs-template/Industry Specific Roles.png";
import LeadershipAndCSuiteRecruitment from "assets/images/jobs-template/Leadership and C-Suite Recruitment.png";
import ProfessionalAndMidLevelRoles from "assets/images/jobs-template/Professional and Mid-Level Roles.png";
import RemoteAndHybridRoles from "assets/images/jobs-template/Remote and Hybrid Roles.png";
import SalesAndCustomerFacingRoles from "assets/images/jobs-template/Sales and Customer-Facing Roles.png";
import TechnicalAndSpecializedSkills from "assets/images/jobs-template/Technical and Specialized Skills.png";

export const categoryImageMap: Record<string, string> = {
  "Culture and Team Fit": CultureAndTeamFit,
  "Diversity and Inclusion": DiversityAndInclusion,
  "Generic Assessments": GenericAssessments,
  "Graduate and Entry-Level Hiring": GraduateAndEntryLevelHiring,
  "High-Volume Hiring": HighVolumeHiring,
  "Industry-Specific Roles": IndustrySpecificRoles,
  "Leadership and C-Suite Recruitment": LeadershipAndCSuiteRecruitment,
  "Professional and Mid-Level Roles": ProfessionalAndMidLevelRoles,
  "Remote and Hybrid Roles": RemoteAndHybridRoles,
  "Sales and Customer-Facing Roles": SalesAndCustomerFacingRoles,
  "Technical and Specialized Skills": TechnicalAndSpecializedSkills
};

// Then inside your component, add this function
export const getCategoryImage = (categoryName: string | undefined): string => {
  if (!categoryName) return JobTemplateIcon;

  // Return the mapped image or fallback to default
  return categoryImageMap[categoryName] || JobTemplateIcon;
};
